/**
 * Classical Columns (Static_Menu_Grid) layout density.
 * Arrangement stays on `registryBlockKey`; this content flag only caps CSS columns.
 */
export const MENU_GRID_COLUMNS = {
  two: '2',
  three: '3',
} as const;

export const MENU_GRID_COLUMNS_VALUES = [
  MENU_GRID_COLUMNS.two,
  MENU_GRID_COLUMNS.three,
] as const;

export type MenuGridColumns = (typeof MENU_GRID_COLUMNS_VALUES)[number];

export function isMenuGridColumns(value: string): value is MenuGridColumns {
  return (MENU_GRID_COLUMNS_VALUES as readonly string[]).includes(value);
}

/** Default Classical Columns density — three columns from ~900px. */
export const DEFAULT_MENU_GRID_COLUMNS: MenuGridColumns = MENU_GRID_COLUMNS.three;

/** Reads optional `menuGridColumns` from block content (same value across locales). */
export function readMenuGridColumnsOverride(
  content: Record<string, Record<string, string>>,
): string | undefined {
  const field = content.menuGridColumns;
  if (!field) {
    return undefined;
  }
  const raw = field.de ?? field.en ?? field.vi ?? Object.values(field)[0];
  return typeof raw === 'string' && raw.length > 0 ? raw : undefined;
}

/** Priority: stored `menuGridColumns` → default `3`. */
export function resolveMenuGridColumns(
  content: Record<string, Record<string, string>> | undefined,
): MenuGridColumns {
  const raw = content ? readMenuGridColumnsOverride(content) : undefined;
  if (raw && isMenuGridColumns(raw)) {
    return raw;
  }
  return DEFAULT_MENU_GRID_COLUMNS;
}
